// Environment configuration for Dev (dev.creator.davaco.cloud)
export const environment = {
  production: false,
  // Feature variables — gate in-progress form-builder toggles. Off until product
  // asks for them to be visible (issues #139 Photo Hyperlink / #140 Exception Report).
  features: {
    photoHyperlink: false,
    exceptionReport: false,
  },
  // Customers whose surveys are left out of the Assignment list. Production
  // hides its test customers; dev shows everything.
  assignmentHiddenCustomers: [] as string[],
apiBase: "https://dev.api.creator.davaco.cloud",
  documentApiBase: "https://dev.api.document.davaco.cloud",
  navBase: "https://ctv2026-navigation.salmonrock-b20cc3ba.southcentralus.azurecontainerapps.io",
  collectionApiBase: "https://dev.api.collection.davaco.cloud",
  // Security service API base -- AAD survey-takers roster. No custom domain is
  // bound for security-service, so this is the container app FQDN.
  securityApiBase: "https://ctv2026-security.salmonrock-b20cc3ba.southcentralus.azurecontainerapps.io",
  // Feedback service API base — used by the Report a Bug/Feature form.
  // CONFIRM: verify this FQDN against the actual deployed ctv2026-feedback container app FQDN.
  feedbackApiBase: "https://ctv2026-feedback.salmonrock-b20cc3ba.southcentralus.azurecontainerapps.io",
  // Notification service API base — Notifications screen (Notification 2.0).
  notificationApiBase: "https://ctv2026-notification.salmonrock-b20cc3ba.southcentralus.azurecontainerapps.io",
  // Service-provider UI app — opened in a new tab from the creator UI.
  serviceProviderAppUrl: "https://sp-ui-dev.salmonrock-b20cc3ba.southcentralus.azurecontainerapps.io",
  // Photo QC analysis-report app — opened in a new tab from the survey list.
  photoQcBaseUrl: "https://dev.photo-qc.davaco.ai",
  // Service-provider-service API base — used by the survey-assignment
  // "Service Providers" tab to list active providers' employees.
  serviceProviderApiBase: "https://sp-service-api.salmonrock-b20cc3ba.southcentralus.azurecontainerapps.io/api/v1",
  logging: {
    level: "debug",
    enableConsole: true,
  },
  msalConfig: {
    auth: {
      clientId: "06e4c767-b293-4d6c-a6dd-920f94370c18",
      authority: "https://login.microsoftonline.com/20266eb8-0c6e-4253-bbdb-e7db3a9dc961",
      redirectUri: "https://dev.creator.davaco.cloud/",
      postLogoutRedirectUri: "https://dev.creator.davaco.cloud",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  },
  scopes: {
    loginRequest: ["openid", "profile", "email"],
    tokenRequest: ["User.Read"],
  },
  apiConfig: {
    scopes: ["api://06e4c767-b293-4d6c-a6dd-920f94370c18/access_as_user"],
    serviceProviderScopes: ["api://06e4c767-b293-4d6c-a6dd-920f94370c18/access_as_user"],
  },
};
